import { render, staticRenderFns } from "./UserDocumentsList.vue?vue&type=template&id=7ea1f1e6&"
import script from "./UserDocumentsList.vue?vue&type=script&lang=js&"
export * from "./UserDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./UserDocumentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports